export default __webpack_public_path__ + "img/21bad8b20679a539a28a5c2f53e7a3e2.svg";